import * as React from 'react'
import {PasswordLostState} from './PasswordLostState'
import {PublicPage} from '../../View/PublicPage'
import {PasswordLostAction} from './PasswordLostActions'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import injectSheet from 'react-jss'
import {WithClasses} from '../../View/Helper'

const styles = {
    loginForm: {
        textAlign: 'center',
        padding: '16px'
    },
}

interface Properties {
    readonly state: PasswordLostState,
    readonly dispatch: (action: PasswordLostAction) => void
}

export const PasswordLost =
    injectSheet<Properties>(styles)(
        ({classes, state, dispatch}: WithClasses<Properties>) => {
            const {input, validation} = state
            return (
                <PublicPage>
                    <form
                        className={classes.loginForm}
                        onSubmit={(event) => {
                            event.preventDefault()
                            dispatch({
                                type: 'Submit',
                            })
                        }}
                    >
                        {state.status.type !== 'EmailSent' ?
                            <p>
                                <p>
                                    <TextField
                                        className="login__input"
                                        errorStyle={{
                                            position: 'absolute',
                                            bottom: '-15px'
                                        }}
                                        floatingLabelText="E-Mail"
                                        fullWidth={true}
                                        errorText={
                                            validation.email === 'Mandatory' ?
                                                'E-Mail ist ein Pflichtfeld' :
                                                validation.email === 'InvalidEmail' ?
                                                    'Ungültige E-Mail-Adresse' :
                                                    state.status.type === 'EmailNotFound' ?
                                                        'E-Mail-Adresse existiert nicht' :
                                                        null}

                                        value={input.email}
                                        onChange={(event, value) => dispatch({
                                            type: 'EmailChanged',
                                            value
                                        })}
                                    />
                                </p>
                                {state.status.type === 'GeneralError' &&
                                <span className="login__network-error">
                            Netzwerkfehler
                        </span>}
                                <br/>
                                <p>
                                    <RaisedButton
                                        label="Passwort zurücksetzen"
                                        type="submit"
                                        primary={true}
                                        className="login__btn"
                                        disabled={state.status.type === 'Loading'}
                                    />
                                </p>
                            </p>
                            :
                            <p>
                                Ein neugeneriertes Passwort wurde an die angegebene
                                E-Mail-Adresse gesendet.<br/>
                                Bitte ändern Sie dieses bei Ihrem nächsten Login.
                            </p>
                        }
                    </form>
                </PublicPage>
            )

        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/PasswordLost/PasswordLostView.tsx